export { CompanionDial } from './CompanionDial.tsx';
export { appChatBridge, reportPathOf } from './app-chat.ts';
export { apps, type App, type AppShare } from './apps/api.ts';

/** Its pages and views the host (or another module) loads when shown. */
export const pages = {
  access: () => import('./access.tsx'),
  agents: () => import('./agents.tsx'),
  'apps/Apps': () => import('./apps/Apps.tsx'),
  'apps/MyApps': () => import('./apps/MyApps.tsx'),
  'apps/OutboundHostsCard': () => import('./apps/OutboundHostsCard.tsx'),
  'apps/SharedApp': () => import('./apps/SharedApp.tsx'),
  governance: () => import('./governance.tsx'),
  models: () => import('./models.tsx'),
  pipeline: () => import('./pipeline.tsx'),
  reports: () => import('./reports.tsx'),
  workflows: () => import('./workflows.tsx'),
};
